// extracted by mini-css-extract-plugin
export default {"tooltip":"JR-z","arrow":"KR-z"};